import React from "react";
import DefaultLayout from "@configuratorware/configurator-frontendgui/App/Modules/Designer/Layouts/DefaultLayout";
import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";

/* const styles = (theme) => ({
 root: {
    // helper classes can be used on contained elements
    width: '100%',
  },
  main: {
    width: '100%',
  },
  sidebar: {
    width: 0,
    margin: 0,
  },
  container: {
    '&.reducedSize': {
      width: 'calc(100% - 140px)',
      marginLeft: 140,
    },
    [theme.breakpoints.between('xs', theme.creator.viewSelectBreakpoint)]: {
      height: 'calc(100% - 136px)',
    },
  },

  outerContainer: {
    height: '100%',
    position: 'relative',
    margin: 0,
  },
  visualization: {
    // the visualization is in the background with absolute positioning
    position: 'absolute',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      height: '75%',
    },
  },
}); */
const styles = (theme) => ({
  root: {
    background: theme.palette.backgroundColor,
    height: "100vh",
    maxHeight: "100vh",
    width: "100vw",
    maxWidth: "100vw",
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "hidden",
    // helper classes can be used on contained elements
    "& .noShrink": {
      flexShrink: 0,
    },
    "& .verticalSpacing": {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    "& .md": {
      [theme.breakpoints.up("md")]: {},
    },
    "& .sm": {
      [theme.breakpoints.down("sm")]: {},
    },
    visualization: {
      // the visualization is in the background with absolute positioning
      position: "absolute",
      width: "100%",
      height: "100%",
      [theme.breakpoints.down("xs")]: {
        height: "75%",
      },
    },
  },
  fallbackMode: {},
  header: {},
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    margin: 0,
    height: "calc(100%)",
    maxHeight: `calc(100% - ${theme.layout.appbar.heightSm +
      theme.layout.footerbar.heightSm * 3 +
      theme.layout.configurationpicker.height * 2 +
      theme.spacing(8)}px)`,
    [theme.breakpoints.up("sm")]: {
      marginTop: 0,
      maxHeight: `calc(100% - ${theme.layout.appbar.height +
        theme.layout.footerbar.height +
        theme.layout.configurationpicker.height +
        theme.spacing(4) * theme.spacingMultiplicator.md}px)`,
    },
    [theme.breakpoints.up("xl")]: {
      maxHeight: `calc(100% - ${theme.layout.appbar.heightXL +
        theme.layout.footerbar.height +
        theme.layout.configurationpicker.heightXL +
        theme.spacing(4) * theme.spacingMultiplicator.xl}px)`,
    },
    // margin: `0px ${theme.spacing(2)}px`,
    position: "relative",
    // overflow: 'scroll',
    // overflow: 'hidden',
  },
  containerTabletPortrait: {
    flexDirection: "column",
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    position: "relative",
    height: `calc(100% - ${theme.layout.productsList.height}px)`,
    marginTop: theme.layout.productsList.height,
    // the pointer events should be passed through to the visualization component
    pointerEvents: "none", // important: don't remove this
  },
  sidebar: ({ isPortraitMode }) => ({
    height: "100%",
    width: "100%",
    zIndex: 12,
    position: "absolute",
    bottom: theme.layout.footerbar.height,
    // the pointer events should be passed through to the visualization component
    pointerEvents: "none", // important: don't remove this
  }),
  toBottom: {
    marginTop: "auto",
  },
  overlayContainer: {
    position: "absolute",
    height: "100%",
    zIndex: 12,

    [theme.breakpoints.down("xs")]: {
      position: "absolute",
    },
  },
  graphicsEditorWrapper: {
    maxWidth: theme.layout.sidebar.width,
    width: "100%",
    marginLeft: "auto",
    marginRight: "0",
  },
  productPartsList: {},
  designPicker: {
    position: "absolute",
    width: "100%",
    "& > .horizontal": {
      marginBottom: 0,
      background: theme.palette.backgroundColor,
      width: "100%",
      bottom: "auto",
      height: theme.layout.productsList.height,
      [theme.breakpoints.up("xl")]: {
        height: theme.layout.productsList.heightXL,
      },

      [theme.breakpoints.up("sm")]: {
        marginBottom: theme.spacing(7),
      },
      [theme.breakpoints.up("xl")]: {
        marginBottom: theme.spacing(7),
      },
      // Zum Überschreiben:
      "& .horizontal.carousel-wrapper ": {
        marginBottom: 0,
      },

      "& .carousel": {
        margin: theme.spacing(0, 3 * theme.spacingMultiplicator.md),
        width: `calc(100% - ${theme.spacing(
          6 * theme.spacingMultiplicator.md
        )}px)`,

        [theme.breakpoints.up("sm")]: {
          margin: theme.spacing(0, 3 * theme.spacingMultiplicator.md),
          width: `calc(100% - ${theme.spacing(
            6 * theme.spacingMultiplicator.md
          )}px)`,
        },
        [theme.breakpoints.up("xl")]: {
          margin: theme.spacing(0, 2 * theme.spacingMultiplicator.xl),
          width: `calc(100% - ${theme.spacing(
            4 * theme.spacingMultiplicator.xl
          )}px)`,
        },
      },
    },
    "& > .resetviewrow ": {
      margin: theme.spacing(0, 3),
      width: `calc(100% - ${theme.spacing(6)}px)`,
      [theme.breakpoints.up("sm")]: {
        margin: theme.spacing(0, 3 * theme.spacingMultiplicator.md),
        width: `calc(100% - ${theme.spacing(
          6 * theme.spacingMultiplicator.md
        )}px)`,
      },
      [theme.breakpoints.up("xl")]: {
        margin: theme.spacing(0, 2 * theme.spacingMultiplicator.xl),
        width: `calc(100% - ${theme.spacing(
          4 * theme.spacingMultiplicator.xl
        )}px)`,
      },
    },
  },
});

const CustomDesignerDefaultLayout = ({
  width,
  classes,
  renderHeader,
  renderMain,
  renderSidebar,
  renderVisualization,
  renderLoader,
  renderLicenseNotice,
  fallbackMode,
  isPortraitMode,
  renderDesignPicker,
}) => (
  <div
    className={`${classes.root} ${fallbackMode ? classes.fallbackMode : ""}`}
  >
    {renderLicenseNotice()}
    <div className={classes.header}>
      {renderHeader({
        area: "header",
        width,
        classes,
      })}
    </div>
    <div
      className={`${classes.container} ${
        isPortraitMode ? classes.containerTabletPortrait : ""
      }`}
    >
      {!fallbackMode && (
        <div className={classes.visualization}>{renderVisualization()}</div>
      )}
      <div className={classes.designPicker}>{renderDesignPicker()}</div>
      <div className={classes.main}>
        {renderMain({
          area: "main",
          width,
          classes,
        })}
      </div>
      <div className={classes.sidebar}>
        {renderSidebar({
          area: "sidebar",
          width,
          classes,
        })}
      </div>
    </div>

    {renderLoader()}
  </div>
);

export default withStyles(styles, { name: "DefaultLayout" })(
  withWidth({ initialWidth: "xl" })(CustomDesignerDefaultLayout)
);
